import type { ApiResponse } from '../api-types'
import type { Detail } from '../orders/orders-types'

import type { Item, ItemPayload, ItemsMultiupdatePayload, ItemsQueryParams } from './items-types'
import { api } from '@/api/api'

export const itemsService = {
  get: async (params: ItemsQueryParams) => {
    const { data } = await api.get<ApiResponse<Detail>>('/items/', {
      params
    })

    return data
  },

  getById: async (id: string) => {
    const { data } = await api.get<Detail>(`/items/${id}/`)

    return data
  },

  add: async (payload: ItemPayload) => {
    const { data } = await api.post<Item>('/items/', payload)

    return data
  },
  addImage: async (autoid: string, payload: FormData) => {
    const { data } = await api.post<Item>(`/items/${autoid}/files/?overwrite_file=true`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })

    return data
  },
  update: async (id: number, payload: Partial<ItemPayload>) => {
    const { data } = await api.patch<Item>(`/items/${id}/`, payload)

    return data
  },
  multiupdate: async (payload: ItemsMultiupdatePayload) => {
    const { data } = await api.post<Item>('/items/multiupdate/', payload)

    return data
  }
}
